<template>
  <el-container class="form-design-container">
    <el-header height="45px" class="form-design-header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>表单设计</el-breadcrumb-item>
        <el-breadcrumb-item v-if="!nameAttr.showNameInput">{{definition.name || '未命名'}}<i class="el-icon-edit-outline name" @click="changeName"></i></el-breadcrumb-item>
        <el-input class="name-input" ref="nameInput" v-else v-model="definition.name" @change="saveName" @blur="saveName"  @keyup.esc.native="recallName"></el-input>
      </el-breadcrumb>
      <div class="header-buttons">
        <el-button @click="attr">全局设置</el-button>
        <el-dropdown split-button type="primary" @click="save(false)">
          <i v-if="saveAccomplish" class="el-icon-loading"></i>
          保存
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item><a @click="save(true)">保存并关闭</a></el-dropdown-item>
            <el-dropdown-item v-if="!create"><a @click="clone" title="基于本表单创建新表单">复制</a></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span class='fullScreen' :title="isFullScreen?`退出全屏`:`全屏`" :class="[isFullScreen?'exit':'']" @click="toggleFullScreen"></span>
      </div>
    </el-header>
    <component-design :form="definition.form" ref="compoentDesign">
      <label slot="form"><span class="first">控件布局</span></label>
      <div class="design-buttons" slot="formButtons">
        <el-button v-for="button in definition.buttons" :key="button.id" :type="button.type==='comfirm'?'primary':''" @click="changeDefinitionButton">{{button.name}}</el-button>
        <el-button type="text" @click="changeDefinitionButton" icon="el-icon-setting">设置按钮</el-button>
      </div>
    </component-design>
    <form-design-dialog v-if="page.dialog.visible" :page="page" :formId='definition.id' @setDefinitionButtons="setDefinitionButtons" @setDefinitionName="setDefinitionName"></form-design-dialog>
  </el-container>
</template>

<script>
import FormDesignDialog from './form-design-dialog.vue'
import ComponentDesign from './component-design.vue'
import { Loading } from 'element-ui'
import { fullscreenMixin } from '../../shared/designMixins/mixins'
import Definition from '@/store/form/definition'
import Schema from '@/store/form/schema'
import FormService from '@/store/form/formService'
import Report from '@/store/report/report'
import _ from 'lodash'
import Column from '@/store/report/column'
import ColorFormat from '@/store/report/colorFormat.js'
import DisplayFormat from '@/store/report/displayFormat.js'
import DataFormat from '@/store/report/dataFormat.js'
import ReportService from '@/store/report/reportService'
import {UUID} from '../../../plugins/common'
import Button from '@/store/report/button'

export default {
  name: 'FormDesign',
  props: ['id', 'formValue'],
  provide: {
    formService: {},
    componentCount: {},
    sortComponent: {},
    reportService: new ReportService()
  },
  mixins: [ fullscreenMixin ],
  data () {
    return {
      create: true,
      searchKeyword: '',
      page: {
        dialog: {visible: false, title: '', view: ''},
        defineId: '',
        formName: '',
        buttons: [],
        formAttr: {},
        componentInteraction: [],
        formValidates: []
      },
      definition: {},
      schmea: new Schema(),
      loading: {},
      saveAccomplish: false,
      sortComponent: {
        state: false
      },
      nameAttr: {
        showNameInput: false,
        oldName: ''
      }
    }
  },
  components: {
    FormDesignDialog,
    ComponentDesign
  },
  created () {
    this._provided.componentCount = {}
    this._provided.formService = new FormService()
    this._provided.formService.loadTables()
    this._provided.sortComponent = this.sortComponent
    this.fullscreenchange()
    if (this.id) {
      this.create = false
      this.$axios.get('/form-api/defines/' + this.id)
        .then(res => {
          this.definition = new Definition(res.data)
          this.formValue.oldValue = JSON.stringify(this.$_.cloneDeep(this.definition))
          this.formValue.newValue = this.definition
          this.schmea.load(res.data.form.schema)
          this._provided.formService.formMainTableId = this.definition.form.archive.tableId // 当前表单的主表id
          this._provided.formService.schema = this.schmea
          this._provided.formService.component = this.definition.form
        })
    } else {
      this.definition = new Definition()
      this.schmea.createTable(this.definition.form.archive.tableId, this.definition.name)
      this._provided.formService.schema = this.schmea
      this._provided.formService.component = this.definition.form
    }
    this._provided.formService.loadDataReports()
  },
  methods: {
    isCloseComponentAttr () {
      if (this.$refs.compoentDesign.$refs.ComponentAttr && this.$refs.compoentDesign.$refs.ComponentAttr.component) {
        this.$message({
          message: '请先保存控件属性',
          center: true,
          duration: 3000,
          customClass: 'without-execute-dialog'
        })
        return Promise.reject(new Error('请先保存控件属性'))
      } else {
        return Promise.resolve()
      }
    },
    save (close) {
      // 如果正在保存则直接返回
      if (this.saveAccomplish) {
        return false
      }
      this.saveAccomplish = true
      this.isCloseComponentAttr()
      // 校验表单名字
        .then(() => this.validateFormName(close))
        // 校验控件名是否重复
        .then(() => this.promiseCheckNameRepeat(this.definition.form))
        // 提交前确认提交
        .then((data) => this.confirmSubmit(data))
        // 提交数据
        .then(() => this.submit('/form-api/defines'))
        // 弹出提示或关闭页
        .then(() => {
          this.formValue.oldValue = JSON.stringify(this.$_.cloneDeep(this.definition))
          this.formValue.newValue = this.definition
          this.saveAccomplish = false
          // 一键生成报表
          if (this.create) {
            this.newSameReport()
          }
          this.$nextTick(() => {
            this.create = false
            if (close) {
              return this.closeForm()
            } else {
              return this.tips()
            }
          })
        })
        .catch(() => {
          this.saveAccomplish = false
        })
    },
    async validataReportName (report) {
      let nameObj = await this.validateRepeatName(report)
      if (!nameObj.haveRepeatName) {
        return report.name
      } else {
        report.name = `${report.name}01`
        return this.validataReportName(report)
      }
    },
    // 表单保存时生成一个对应的归档表报表
    async newSameReport () {
      let report = Report.create()
      report.mainTableId = this.definition.form.archive.tableId
      this._provided.reportService.report = report
      report.name = this.definition.name
      report.dataSourceReport = false
      // 递归校验名字重名
      report.name = await this.validataReportName(report)
      this.loadMatbleTableColumns(this.definition.form.archive.tableId)
        .then(async data => {
          // 去除审计字段
          let fiterColumns = data.columns.filter(n => !(n.id.includes(this.definition.form.archive.tableId.slice(0, 35)) || (n.dataType === 'IDENTITY' && n.primaryKey === true && n.columnName === 'id')))
          // 生成全部的报表列
          await Promise.all(fiterColumns.map(item => this.addColumn(item)))
            .then((columns) => {
              columns.forEach(m => {
                this._provided.reportService.createOrUpdate(m)
              })
              let buttons = []
              // 默认指向当前表单
              buttons.push(new Button({name: '新建', type: 'create', targetId: this.definition.id}))
              buttons.push(new Button({name: '修改', type: 'update', targetId: this.definition.id}))
              // 删除按钮默认开启操作提醒
              buttons.push(new Button({name: '删除', type: 'delete', tipsEnable: true, tip: '您确定执行此操作吗?'}))
              // 生成 新建、修改、删除
              this._provided.reportService.report.buttons = buttons
              this._provided.reportService.publish()
            })
        })
    },
    async loadMatbleTableColumns (tableId) {
      return (await this.$axios.get(`/data-api/table/${tableId}`)).data
    },
    async validateRepeatName (report) {
      return (await this.$axios.get(`/report-api/report/definition/haveRepeatName/${report.id}`, {params: {name: report.name, dataSourceReport: false}})).data
    },
    addColumn (column) {
      return new Promise(async (resolve) => {
        if (column) {
          let pingyin = await this._provided.reportService.getPinyinByHanzi(column.name)
          _.merge(column, {...pingyin})
          let reportColumn = Column.create(column)
          reportColumn.columnType = column.dataType || column.columnType
          let colorFormat = new ColorFormat()
          reportColumn.format.colorFormats.push(colorFormat)
          let displayFormat = new DisplayFormat()
          reportColumn.format.displayFormats.push(displayFormat)
          reportColumn.format.dataFormat = new DataFormat()
          this.$nextTick(() => {
            resolve(reportColumn)
          })
        }
      })
    },
    clone () {
      this.isCloseComponentAttr()
      // 校验表单名字，clone不需要关闭表单
        .then(() => this.validateFormName(false))

      // 校验控件名是否重复
        .then(() => this.promiseCheckNameRepeat(this.definition.form))
        // 提交前确认提交
        .then((data) => this.confirmSubmit(data))
        // 提交数据
        .then(() => this.openLoading())
        .then(() => this.submit('/form-api/defines/clone'))
        .then(() => {
          this.loading.close()
          this.$message({
            message: '复制成功',
            center: true,
            duration: 1000,
            customClass: 'without-execute-dialog'
          })
        })
        // 弹出提示或关闭页面
        .catch(() => {
          if (this.loading) {
            this.loading.close()
          }
        })
    },

    openLoading () {
      this.loading = Loading.service({
        lock: false,
        text: '正在复制, 请稍后...',
        customClass: 'loading',
        spinner: '',
        background: 'rgba(0, 0, 0, 0.4)'
      })
    },

    async validateFormName (close) {
      if (this.definition.name === '') {
        this.changeDefinitionName()
        this.page.dialog.isPublish = close
        this.page.dialog.isSave = true
        return Promise.reject(new Error('请先设置表单名称'))
      } else {
        await this.$axios.get(`/form-api/defines/${this.definition.id}/validateName?name=${this.definition.name}`)
          .then(res => {
            if (res) {
              return Promise.resolve()
            } else {
              this.$message.info('该表单名称已存在，请更换表单名称')
              return Promise.reject(new Error('该表单名称已存在，请更换表单名称'))
            }
          })
      }
    },

    confirmSubmit (data) {
      return new Promise((resolve, reject) => {
        if (data) {
          this.$confirm('', `${data}`, {
            confirmButtonText: '是',
            cancelButtonText: '否',
            customClass: 'publishMessageBox',
            center: true
          }).then(() => resolve())
            .catch(() => reject(new Error('用户取消提交')))
        } else {
          resolve()
        }
      })
    },

    submit (url) {
      const model = this._provided.formService.build()
      const definition = this.$_.cloneDeep(this.definition)
      definition.comment = this.getComment()
      definition.form = model
      return this.$axios.post(`${url}`, definition)
    },
    // 增加备注信息
    getComment () {
      if (!this.id) return ''
      // formValidates 操作校验
      // interactions 数据联动
      // 控件交互和基本属性都在 form 的 properties 中
      let oldValue = JSON.parse(this.formValue.oldValue).form
      let newValue = this.formValue.newValue.form
      // 表单修改过
      let comment = ''
      if (JSON.stringify(oldValue) !== JSON.stringify(newValue)) {
        // 判断控件是否修改
        if (JSON.stringify(oldValue.children) !== JSON.stringify(newValue.children)) {
          comment += '更新控件、'
        }
        if (
          JSON.stringify(oldValue.formValidates) !== JSON.stringify(newValue.formValidates) ||
          JSON.stringify(oldValue.interactions) !== JSON.stringify(newValue.interactions) ||
          JSON.stringify(oldValue.properties) !== JSON.stringify(newValue.properties)
        ) {
          comment += '更新属性'
        }
      }
      if (comment && comment.charAt(comment.length - 1) === '、') {
        comment = comment.slice(0, comment.length - 1)
      }
      return comment
    },

    tips () {
      this.$message({
        message: '表单保存成功',
        center: true,
        customClass: 'message-form-save',
        type: 'success'
      })
    },

    attr () {
      // 打开表单属性面板
      this.openDialog('formAttrDialog', '')
      let originalComponent = this._provided.formService.getComponentById(this.definition.form.id)
      this.page.formAttr = this.$_.cloneDeep(originalComponent)
      this.page.formAttr.name = this.definition.name
      // 控件交互的执行的控件的是数组
      let componentInteraction = this.$_.cloneDeep(this._provided.formService.component.properties.componentInteraction)
      if (componentInteraction) {
        componentInteraction.forEach(m => {
          // 手动添加一个id给vue区分
          if (!m.id) {
            m.id = UUID.create()
          }
          if (!m.triggerComponents) {
            m.relation = true
            m.triggerComponents = [{triggerComponent: m.triggerComponent, triggerType: m.triggerType, compareVal: m.compareVal}]
            delete m.triggerComponent
            delete m.triggerType
            delete m.compareVal
          }
          m.conforms.forEach(n => {
            n.changeComponent = typeof (n.changeComponent) === 'string' ? n.changeComponent.split(',') : n.changeComponent
          })
          m.noConforms.forEach(n => {
            n.changeComponent = typeof (n.changeComponent) === 'string' ? n.changeComponent.split(',') : n.changeComponent
          })
        })
      }
      this.page.componentInteraction = componentInteraction ? componentInteraction.reverse() : [] // 兼容倒序展示,取的时候要反过来 存的时候再反一次
      // 将操作校验的字符串转化下
      let formValidates = this.$_.cloneDeep(this._provided.formService.component.formValidates)
      if (formValidates) {
        formValidates.forEach(m => {
          m.operationType = typeof (m.operationType) === 'string' ? m.operationType.split(',') : m.operationType
        })
      }
      this.page.formValidates = formValidates ? formValidates.reverse() : [] // 兼容倒序展示,取的时候要反过来 存的时候再反一次
      // 数据联动
      let interactions = this.$_.cloneDeep(this._provided.formService.component.interactions)
      if (interactions) {
        interactions.forEach(m => {
          m.type = typeof (m.type) === 'string' ? m.type.split(',') : m.type
        })
      }
      this.page.interactions = interactions ? interactions.reverse() : [] // 兼容倒序展示,取的时候要反过来 存的时候再反一次
      this.page.formName = this.definition.name
    },

    promiseCheckNameRepeat (component) {
      return new Promise(resolve => {
        let repeatComponent = this.checkNameRepeat(component)
        if (repeatComponent && repeatComponent.length !== 0) {
          resolve(`以下控件名称重复: ${repeatComponent.join((', '))}, 您确认提交吗`)
        } else {
          resolve()
        }
      })
    },

    checkNameRepeat (componment) {
      let componentName = []
      let repeatName = []
      componment.archivedChildren && componment.archivedChildren.forEach(m => {
        if (m.archivedChildren && m.archivedChildren.length !== 0) {
          repeatName = repeatName.concat(this.checkNameRepeat(m))
        }
        if (componentName.includes(m.name)) {
          repeatName.push(`${componment.name}-${m.name}`)
        } else {
          componentName.push(m.name)
        }
      })
      return repeatName
    },

    openDialog (view, title) {
      this.page.dialog = {
        visible: true,
        view,
        title,
        isPublish: false
      }
    },
    changeName () {
      this.nameAttr.name = this.definition.name
      this.nameAttr.showNameInput = true
      this.$nextTick(() => {
        this.$refs.nameInput.focus()
        this.$refs.nameInput.select()
      })
    },
    saveName () {
      if (!this.definition.name) {
        this.$message.info('表单名称为空')
      }
      this.definition.form.name = this.definition.name
      this._provided.formService.updataArchiveName(this.definition.form)
      this.nameAttr.showNameInput = false
    },
    // esc撤回
    recallName () {
      this.definition.name = this.nameAttr.name
      this.nameAttr.showNameInput = false
    },
    changeDefinitionName () {
      this.openDialog('changeNameDialog', '表单名称设置')
      this.page.defineId = this.definition.id
      this.page.formName = this.definition.name
    },
    setDefinitionName (obj) {
      this.definition.form.name = obj.name
      this._provided.formService.updataArchiveName(this.definition.form)
      this.definition.name = obj.name
      this.$message({
        message: '表单名称保存成功',
        center: true,
        customClass: 'message-form-save',
        type: 'success'
      })
      // 点击保存之后需要保存表单，修改名字不需要
      obj.isSave && this.save(obj.isPublish)
    },
    changeDefinitionButton () {
      this.openDialog('changeButtonsDialog', '表单操作按钮设置')
      this.page.buttons = this.$_.cloneDeep(this.definition.buttons)
      this.page.buttons.forEach(m => {
        m.tip = m.tip || '您确定执行此操作吗?'
      })
    },
    setDefinitionButtons (buttons) {
      this.definition.buttons = buttons
    },
    closeForm () {
      this.$emit('closeForm')
    }
  },
  watch: {
    // 控件如果改变了顺序，是前端手动排序的，和返回的数据结构上会有差异，需要在排序完成之后再保存
    'sortComponent.state' (val) {
      if (val) {
        this.formValue.oldValue = JSON.stringify(this.$_.cloneDeep(this.definition))
        this.formValue.newValue = this.definition
      }
    }
  }
}
</script>

<style lang="scss">
.form-design-container {
  .el-dropdown {
    height: 30px;
    line-height: 30px;
  }
  // 禁止选中文字
  -moz-user-select: none;
  -o-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  height: 100%;
  .form-design-header {
    background: #fff;
    line-height: 45px;
    box-shadow: 4px 4px 4px rgba(174, 222, 251, 0.1);
    padding: 0 12px 0 26px;
    &:after {
      content: "";
      display: block;
      clear: both;
    }
    .el-breadcrumb {
      display: inline-block;
      line-height: 45px;
      span {
        font-weight: 700;
        font-size: 15px;
        &:hover{
           font-weight: 700;
        }
      }
      .name {
        vertical-align: middle;
        margin-left: 10px;
        color: #409EFF;
        cursor: pointer;
      }
      .name-input {
        display: inline-block;
        width: 136px;
      }
    }
    .header-buttons {
      float: right;
      >.el-button {
        padding: 7px 0;
        width: 62px;
        &:nth-child(1) {
          margin-right: 20px;
        }
      }
      .el-dropdown .el-button{
        padding: 7px 5px;
        &:nth-child(1) {
          padding: 7px 15px;
        }
      }
    }
  }
}

.loading {
  .el-loading-spinner {
    .el-loading-text {
      width: 260px;
      height: 68px;
      line-height: 68px;
      text-align: center;
      margin: 0 auto;
      background: #ffffff;
      border-radius: 4px;
      color: #000000;
    }
    .circular {
      display: none;
    }
  }

}
.el-message.el-message--info.is-center.without-execute-dialog{
  min-width: 136px;
  min-height: 36px;
  height: 36px;
  position: fixed;
  left: calc(50% + 100px);
  top: 40%;
  background-color: #29282E;
  >p{
    font-size: 12px;
    color: #FFFFFF;
  }
  >i{
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/design/form-design.vue